<template>
  <!-- 满减券领取 -->
  <div class="course-info">
    <div class="content-bg">
      <div class="content-inner">
        <div class="content-info">
          <img class="logo" src="~@/assets/images/invitation/logo.png" alt="" />
          <div class="content-footer">
            <img class="content-banner" :src="dataInfo.imageA" alt="" />
            <div class="content-item">
              <p class="light-color">
                <em>￥</em>
                <span class="price">{{dataInfo.price}}</span>
              </p>
              <span>{{dataInfo.inviteTitle}}</span>
            </div>
            <div class="content-item mt40 ">
              <p class="mb10"><strong>使用须知</strong></p>
              <span class="invitation-know">{{dataInfo.content}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- useStatus 用户领取状态[0:未领取,1:已领取，2：已领完 3：已过期] -->
      <div v-if="dataInfo.useStatus == 0">
        <p>领取有效期至：{{dateInfo(dataInfo.endTime)}}</p>
        <GxxtButton @click="getCourse" type="primary" size="large" style="width: 90%;">立即领取</GxxtButton>
      </div>
      <div v-else-if="dataInfo.useStatus == 1">
        <p>您已领过该课程！</p>
        <GxxtButton @click="useCoupon" type="primary" size="large" style="width: 90%;">查看课程</GxxtButton>
      </div>
      <!-- 已被领完 -->
      <div v-else-if="dataInfo.useStatus == 2">
        <p >课程已被领完！</p>
        <GxxtButton @click="getCourse" type="primary" size="large"
          style="width: 90%;background: linear-gradient(90deg, #D6D6D6 0%, #C1C1C1 100%);">
          立即领取
        </GxxtButton>
      </div>
      <div v-else-if="dataInfo.useStatus == 3">
        <p >课程已被领完！</p>
        <GxxtButton type="primary" size="large"
          style="width: 90%;background: linear-gradient(90deg, #D6D6D6 0%, #C1C1C1 100%);">
          已过期
        </GxxtButton>
      </div>
    </div>
    <!-- 弹框 -->
    <!-- 领取成功 -->
    <!-- success 保存状态[0:领取失败,1:领取成功,2:已领取，3：已领完 4：已过期] -->
    <div class="dialog" v-if="isShow">
      <div class="dialog-inner">
        <span class="close" @click="closeDialog"></span>
        <div v-if="successInfo.success == 1">
          <p class="dialog-title">
            <img src="~@/assets/images/invitation/success.png" alt="" srcset="">
            领取成功
          </p>
          <p class="dialog-subtitle">恭喜您已成功领取该课程！</p>
          <GxxtButton @click="useCoupon" type="primary" size="large" style="width: 90%;">查看课程</GxxtButton>
        </div>
        <div v-else-if="successInfo.success == 2">
          <p class="dialog-subtitle" style="margin:10px auto 50px">您已领过该课程！</p>
          <GxxtButton @click="useCoupon" type="primary" size="large" style="width: 90%;">查看课程</GxxtButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GxxtButton } from '@/components'
import { setShareInfo } from '@/utils/storage'
import { wxShare } from '@/utils/wx-config'
import dates from '@/utils/dates'
export default {
  components: {
    GxxtButton,
  },
  data() {
    return {
      dataInfo: {},
      url: '',
      id: '',
      data: '',
      course: false,
      userInfo: {},
      jumpType: 0,
      dates,
      isShow: false,
      successInfo:{}
    }
  },
  created() {
    this.getPresentInfo()
  },
  computed: {
    goodsFlag() {
      return this.dataInfo.goodsNum - this.dataInfo.goodsClaimNum
    },
  },

  filters: {
    useStatus(value) {
      console.log(value);
      
      // let timeArr = value.split('T');
      // return timeArr[0];
    }
  },
  methods: {
    dateInfo(time){
      if(time){
        var date = new Date(time);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        let D = date.getDate() + ' ';
        let h = date.getHours();
        let m = date.getMinutes();
        let s = date.getSeconds(); 
        D = D <10?'0'+D:D;
        h = h <10?'0'+h:h;
        m = m <10?'0'+m:m;
        return Y+M+D+h+':'+m;
      }
    },
    closeDialog() {
      this.isShow = false
    },
    async userLoginInfo(type) {
      let res = await this.api.login.userLoginInfo()
      if (res && res.code == 200) {
        this.getCoupon()
      }
    },
    async getPresentInfo() {
      let id = this.$route.query.inviteId
      let res = await this.api.my.getInviteCodeInfo(id)
      if (res.code == 200) {
        this.dataInfo = res.data
        // this.dataInfo.type = res.data.type
        // this.dataInfo.resourceId = res.data.resourceId
        let shareInfo = {
          title: '我领到优惠券了！名额有限，速速来领。',
          desc: '您收到一张优惠券，快来点击领取',
          link: window.location.href,
          imgUrl: this.constants.logo,
        }
        
        setShareInfo(shareInfo)
        wxShare({
          shareInfo,
        })
      }
    },
    useCoupon() {
      if (this.dataInfo) {
        this.$router.push({
          path: '/course',
          query: {
            goodsId: this.dataInfo.goodsId,
            goodsType: this.dataInfo.type,
          },
        })
      } else {
        this.$router.push({
          name: 'home',
          query: {
            adminId: this.$route.query.adminId,
          },
        })
      }
    },
    async getCoupon() {
      let id = this.$route.query.inviteId
      let res = await this.api.my.getCourseByCode(id)
      if (res && res.code == 200) {
      // success 保存状态[0:领取失败,1:领取成功,2:已领取，3：已领完 4：已过期]
        // this.dataInfo.useStatus = res.data.success;
        // console.log(this.dataInfo)
        if(res.data.success == 1 || res.data.success == 2){
          this.successInfo = res.data
          this.isShow = true;

        } else {
          this.$toaster({
            message: res.message,
            duration: 3000,
            show: true,
          })
        }
        this.getPresentInfo();
      } else {
        this.$toaster({
          message: res.message,
          duration: 3000,
          show: true,
        })
      }
    },
    //立即领取按钮
    getCourse() {
      this.userLoginInfo()
    },
  },
}
</script>

<style lang="less" scoped>
.course-info {
  width: 100%;
  height: 100%;
  background: #ffffff;

  .content-bg {
    height: 400px;
    background: url('~@/assets/images/invitation/bg.png') no-repeat;
    background-size: 100%;
    position: relative;
    font-family: PingFang-SC-Medium, PingFang-SC;
    // font-weight: 500;
    color: #333333;

    .content-inner {
      position: absolute;
      top: 20px;
      left: 24px;
      width: 702px;
      height: 884px;
      background: url('~@/assets/images/invitation/card.png') no-repeat;
      background-size: 100% 100%;
      padding: 0 20px;
      text-align: left;
      font-size: 28px;

      .content-info {
        position: relative;
        width: 610px;
        height: 100%;
        margin: auto;

        .logo {
          width: 210px;
          margin: 34px 0 80px 10px;
        }

        .content-footer {
          .content-banner {
            width: 100%;
            height: 344px;
            border-radius: 8px;
          }

          .content-item {
            .invitation-know{
              word-break: break-all;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            .mb10 {
              margin-bottom: 8px;
            }
            font-family: PingFang-SC-Medium, PingFang-SC;
            strong{
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight:bold;
            }
            .light-color {
              color: #FF5500;

              em {
                font-style: normal;
              }
            }

            margin: 20px 0;

            .price {
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight:bold;
              font-size: 40px;
            }
          }

          .mt40 {
            margin-top: 40px !important;
            float: left;
          }
        }
      }

      // float: left;

    }
  }

  .footer {
    position: fixed;
    bottom: 74px;
    width: 100%;

    p {
      font-size: 26px;
      text-align: center;
      font-family: PingFang-SC-Medium, PingFang-SC;
      margin-bottom: 20px;
      color: #FF0900;
    }
  }

  // 弹框
  .dialog {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, .4);
    position: fixed;
    top: 0;
    left: 0;

    .dialog-inner {
      position: relative;
      padding: 60px 38px 30px;
      background: #FFFFFF;
      border-radius: 11px;
      z-index: 1;
      width: 550px;
      margin: 400px auto 0;

      .close {
        position: absolute;
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url('~@/assets/images/invitation/close.png') no-repeat;
        background-size: 100%;
        right: 20px;
        top: 20px;
        padding:10px;
      }

      .gxxt-button {
        border-radius: 50px !important;
      }

      .dialog-title {
        font-size: 38px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 48px;
          height: 48px;
          flex-shrink: 0;
          margin-right: 10px;
        }
      }

      .dialog-subtitle {
        margin: 29px auto 76px;
        font-size: 30px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        color: #333333;
      }
    }
  }

}
</style>
